import { Card, Flex, Layout, Spin, Typography } from "antd"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"

import SignUpEmailForm from "../../Components/Forms/SignUpEmailForm"
import LoginHeader from "../../Components/LoginHeader"
import PrivacyPolicy from "../../Components/PrivacyPolicy"
import AuthActions from "../LoginPage/reducer"
import { useAdminAcceptInvitePage } from "./hooks/useAdminAcceptInvitePage"

import "./styles.less"

function AdminAcceptInvitePage() {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { token, verifying } = useAdminAcceptInvitePage()
  const fetching = useSelector((state) => state.auth.fetching)
  const error = useSelector((state) => state.auth.error)

  const handleFinish = (values) => {
    dispatch(
      AuthActions.acceptAdminInviteRequest({
        token,
        first_name: values.first_name,
        last_name: values.last_name,
        new_password: values.password,
        confirm_password: values.confirm
      })
    )
  }

  return (
    <Layout>
      <Spin size="large" spinning={fetching || verifying}>
        <div className="login-row">
          <LoginHeader withLogout />
          <div className="login-content">
            <div className="content-main sign-up">
              <Card className="login-card admin-accept-invite-card">
                <Typography.Text strong className="admin-accept-invite-title">
                  {t("Accept invite")}
                </Typography.Text>

                <Flex vertical gap={0} className="admin-accept-invite-form">
                  <SignUpEmailForm
                    onSubmit={handleFinish}
                    error={error}
                    acceptPolicyAgreement
                    setAcceptPolicyAgreement={() => {}}
                    hideEmail
                  />
                </Flex>
              </Card>

              <PrivacyPolicy />
            </div>
          </div>
        </div>
      </Spin>
    </Layout>
  )
}

export default AdminAcceptInvitePage
